"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ONPeriodicReport;
(function (ONPeriodicReport) {
    ONPeriodicReport["INVENTORY_ADJUSTMENTS"] = "Inventory-Adjustments";
    ONPeriodicReport["DESTRUCTIONS"] = "Destructions";
    ONPeriodicReport["INTERSTORE_TRANSFER_IN"] = "Transfer-In";
    ONPeriodicReport["INTERSTORE_TRANSFER_OUT"] = "Transfer-Out";
})(ONPeriodicReport = exports.ONPeriodicReport || (exports.ONPeriodicReport = {}));
//# sourceMappingURL=index.js.map